module.exports = __webpack_public_path__ + "static/media/S (77).55177ed4.jpg";